/* eslint-disable no-unused-vars */
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  ListItemText,
  Menu,
  MenuItem,
  alpha,
  useTheme,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state/hooks';
import { IState } from '../pick6/store/types';
import { setState } from './store/slice';
import { IRootState } from '../../store/reducer';

interface OwnProps {
  onStateChange?: (item: IState) => void;
  toolbarStyle?: boolean
}
type Props = OwnProps;

const Component = (props: Props) => {
  const defaultStyle = !props.toolbarStyle;
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'state-select',
  });
  const { filters, shopOddsStates } = useSelector((state: IRootState) => state.pickemOptimizer);

  const theme = useTheme();
  const dispatch = useDispatch()

  const handleChange = async (item: IState) => {
    dispatch(setState({
      ...item,
    }));
    // if (onStateChange) {
    //   onStateChange(item);
    // }
    popupState.close();
  };

  const getLabel = () => filters.state?.abbreviation;

  const boxStyle = defaultStyle ? {
    marginRight: '12px',
    '& .MuiButton-root': {
      color: `${alpha(theme.palette.common.white, .87)} !important`,
      fontWeight: 600,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginLeft: 'auto',
    }
  } : {
    '& .MuiButton-root': {
      backgroundColor: 'background.primary'
    },
  };

  return (
    <Box data-filter="states" width="auto" sx={boxStyle}>
      <Button
        size="medium"
        aria-controls="button-menu"
        aria-haspopup="true"
        variant={defaultStyle ? 'outlined' : 'contained'}
        endIcon={<ArrowDropDownIcon color="secondary" />}
        {...bindTrigger(popupState)}
        sx={{
          height: 40,
          width: 60,
          justifyContent: 'space-between',
          textTransform: 'capitalize',
          borderColor: `${alpha(theme.palette.common.white, .3)} !important`,
          '& .MuiButton-outlinedPrimary': {
            color: alpha(theme.palette.common.white, .87),
          },
          '& .MuiSvgIcon-root': {
            color: alpha(theme.palette.common.white, .87),
          },
        }}
      >
        {getLabel()}
      </Button>

      <Menu {...bindMenu({ ...popupState })} anchorEl={popupState.anchorEl} sx={{
        '& ul': {
          display: 'flex',
          flexDirection: 'column',
          scrollbarWidth: 0,
          '& li': {
            paddingLeft: 2
          }
        },
        paper: {
          border: '1px solid #d3d4d5',
          '& .row': {
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'row',
            alignItems: 'center',
            '& .team': {
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              alignItems: 'center',
              minWidth: 100,
              width: 100,
              whiteSpace: 'nowrap',
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                whiteSpace: 'inherit',
              },
              '& .img-wrapper': {
                width: 20,
                height: 20,
                marginRight: 4,
                '& img': {
                  height: '100%',
                  width: '100%',
                  objectFit: 'contain',
                },
              },
              '& p': {
                fontWeight: 500,
              },
            },
            '& span': {
              marginRight: 4,
              marginLeft: 8,
            },
          },
        },
      }}>
        {shopOddsStates?.map((option: IState) => (
          <MenuItem
            dense
            key={option.id}
            onClick={() => handleChange(option)}
          >
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default Component;
